import React from 'react';
import Button from '@ramsey-design-system/button';
const {
  ChevronLeftIcon
} = require('@ramsey-design-system/icons/dist/ChevronLeftIcon');
const {
  ChevronRightIcon
} = require('@ramsey-design-system/icons/dist/ChevronRightIcon');
import PropTypes from 'prop-types';

const PaginatorControl = ({
  pageCount,
  currentPage,
  maxPagesToShow = 5,
  onPageSelected = () => {}
}) => {
  const handlePageClicked = (number) => {
    onPageSelected(number);
  };

  const PreviousButton = ({ visible = true, onClicked = () => {} }) => (
    <Button
      className={`mr-1 rds-Button--neutralSubtle ${visible ? 'visible' : 'invisible'}`}
      icon={ChevronLeftIcon}
      iconOnly={true}
      onClick={() => onClicked(currentPage - 1)}
      size="small"
      aria-label="Previous"
    >
      Previous
    </Button>
  );

  PreviousButton.propTypes = {
    visible: PropTypes.bool,
    onClicked: PropTypes.func
  };

  const NextButton = ({ visible = true, onClicked = () => {} }) => (
    <Button
      className={`rds-Button--neutralSubtle ${visible ? 'visible' : 'invisible'}`}
      icon={ChevronRightIcon}
      iconOnly={true}
      onClick={() => onClicked(currentPage + 1)}
      size="small"
      aria-label="Next"
    >
      Next
    </Button>
  );

  NextButton.propTypes = {
    visible: PropTypes.bool,
    onClicked: PropTypes.func
  };

  const pagesToShow = () => {
    let startPage = 1,
      endPage = pageCount;
    if (pageCount > maxPagesToShow) {
      let maxPagesToShowBeforeCurrentPage = Math.floor(maxPagesToShow / 2);
      let maxPagesToShowAfterCurrentPage = Math.ceil(maxPagesToShow / 2) - 1;
      if (currentPage <= maxPagesToShowBeforeCurrentPage) {
        endPage = maxPagesToShow;
      } else if (currentPage + maxPagesToShowAfterCurrentPage >= pageCount) {
        startPage = pageCount - maxPagesToShow + 1;
      } else {
        startPage = currentPage - maxPagesToShowBeforeCurrentPage;
        endPage = currentPage + maxPagesToShowAfterCurrentPage;
      }
    }
    return Array.from(Array(endPage + 1 - startPage).keys()).map(
      (i) => startPage + i
    );
  };

  const pageNumbers = pagesToShow().map((number) => {
    let classes = `rds-Button--neutralSubtle ${number === currentPage ? 'bg-gray-40' : 'hover:text-blue-60'}`;
    return (
      <Button
        className={classes}
        disabled={currentPage === number}
        key={`page-${number}`}
        onClick={() => handlePageClicked(number)}
        size="small"
      >
        {number.toString()}
      </Button>
    );
  });

  return (
    <nav>
      <nav aria-label="Pagination">
        <ul className="flex gap-sm items-center justify-center p-0">
          <PreviousButton
            onClicked={handlePageClicked}
            visible={currentPage > 1}
          />
          {pageNumbers}
          <NextButton
            onClicked={handlePageClicked}
            visible={currentPage < pageCount}
          />
        </ul>
      </nav>
    </nav>
  );
};

PaginatorControl.propTypes = {
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  totalPageCount: PropTypes.number,
  maxPagesToShow: PropTypes.number,
  onPageSelected: PropTypes.func
};

export default PaginatorControl;
